import { ReactElement } from "react";
import ReactMarkdown from "react-markdown";
import { sanitizeLessonText } from "../../utils/sanitizeLessonText";

interface IProps {
  id?: number;
  title?: string;
  content?: string;
  onClickNextEx: () => void;
}

export function TextLesson(props: IProps): ReactElement {
  const safeTitle = sanitizeLessonText(props.title);
  const safeContent = sanitizeLessonText(props.content);
  return (
    <>
      <div className="lessonPageConteinerText">
        <div className="textConteiner">
          <h1>{safeTitle}</h1>
          <ReactMarkdown>{safeContent}</ReactMarkdown> 
        </div>
      </div>
      <div className="lessonPageOnward-button" onClick={() => props.onClickNextEx()}>
        Далее
      </div>
    </>
  );
}
